import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import RetryPaymentApiAdapter from '../adapters/retryApiAdapter.js';
import { thunkDispatchWithDependencies } from '../dispatch/index.js';
import { useAppContext } from './AppContextProvider.js';
import { useConfig } from './ConfigProvider.js';
import { useRetryState } from './RetryDataProvider.js';

const ThunkDispatchContext = createContext({
    thunkDispatch: () => null,
});
const useThunkDispatch = () => useContext(ThunkDispatchContext);
const ThunkDispatchProvider = ({ children }) => {
    const { config: { retryPaymentBaseUrl }, } = useConfig();
    const { retrySuccessWithData, initiateRetryPaymentFailure, initiateRetryPaymentStart, initiateRetryPaymentSuccess, processPaymentAuthorisationFailure, processPaymentAuthorisationStart, processPaymentAuthorisationSuccess, } = useRetryState();
    const { domain, locale } = useAppContext();
    const retryApi = new RetryPaymentApiAdapter(retryPaymentBaseUrl, domain, locale);
    const dependencies = {
        retryApi,
        retrySuccessWithData,
        initiateRetryPaymentFailure,
        initiateRetryPaymentStart,
        initiateRetryPaymentSuccess,
        processPaymentAuthorisationFailure,
        processPaymentAuthorisationStart,
        processPaymentAuthorisationSuccess,
    };
    const thunkDispatch = thunkDispatchWithDependencies(dependencies);
    return (jsx(ThunkDispatchContext.Provider, { value: { thunkDispatch }, children: children }));
};

export { ThunkDispatchProvider as default, useThunkDispatch };
//# sourceMappingURL=ThunkDispatchProvider.js.map
